
function initializeOnlineBankinglogin() {
  $('.onlineBankingLogin input[type=submit]').bind('click', function () {
    $this = $(this);

    var parent = $(this).closest('.onlineBankingLogin');
    var textfield = parent.find('input[type=text]');
    var value = textfield.val().trim();

    if (value == '') {
      var errorMessage = textfield.attr('data-error-nousername');
      if (errorMessage.trim() != '') {
        alert(errorMessage);
      }
      return false;
    }
  });
}


document.addEventListener('DOMContentLoaded', (event) => {
  initializeOnlineBankinglogin()
})
